import { localizer } from "../../Translator"

export default class EmailValidator {
    static isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        const isValid = emailRegex.test(email)
        if (!isValid) return localizer.InvalidEmail
        return ""
    }

    static equalEmails(email1, email2) {
        if (!email1 || !email2) return localizer.InvalidEmail
        if (email1.trim().toLowerCase() !== email2.trim().toLowerCase()) return localizer.EmailsDoesNotMatch
        return ""
    }
}


// WEBPACK FOOTER //
// ./src/components/Utilities/EmailValidator.js